import React from "react";
import Modal from "../Modal";

const FormModal = ({
  modalShowing,
  closeModal,
  title,
  Form,
  model,
  handleSubmitted,
  formId = "modal-form",
  /** When true, uses opacity-only transitions (no transform). Use for modals with drag-and-drop
   *  since @hello-pangea/dnd has a bug where parent transform causes the drag preview to be offset. */
  useOpacityOnlyTransition = false,
  closeOnBackdropClick = true,
  ...rest
}) => {
  return (
    <Modal
      show={modalShowing}
      onClose={closeModal}
      panelClassName="w-full max-w-md px-5 sm:px-auto sm:max-w-3xl"
      useOpacityOnlyTransition={useOpacityOnlyTransition}
      closeOnBackdropClick={closeOnBackdropClick}
    >
      <div className="flex flex-col justify-center py-8">
        <div className="px-1 sm:mx-auto sm:w-full sm:max-w-2xl">
          <div className="sm:rounded-lg">
            <Form
              model={model}
              closeModal={closeModal}
              handleSubmitted={handleSubmitted}
              title={title}
              formId={formId}
              {...rest}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FormModal;
